/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: OrderDetailsListComponent
 * Purpose		: This component retrieve paged data and performs paging operations
 * Dependency	: OrderDetailsService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { Component, HostBinding, EventEmitter, Input, Output, OnInit, ViewChild,
	trigger, transition, animate,
	style, state } from '@angular/core';
import 'rxjs/add/operator/switchMap';
import { Observable } from 'rxjs/Observable';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ToastsManager }  from 'ng2-toastr';

import myGlobals = require('../globals');
import { OrderDetailsData, OrderDetailsService } from './OrderDetails.service';
import { OrderDetailsSearchComponent }  from './OrderDetailsSearch.component';

@Component({
	selector: 'my-OrderDetails',
	template: require('./OrderDetailsList.component.html'),
	providers: [OrderDetailsService],
	animations: [
    trigger('routeAnimation', [
      state('*',
        style({
          opacity: 1,
          transform: 'translateX(0)'
        })
      ),
      transition(':enter', [
        style({
          opacity: 0,
          transform: 'translateX(-100%)'
        }),
        animate('0.4s ease-in')
      ]),
      transition(':leave', [
        animate('0.7s ease-out', style({
          opacity: 0,
          transform: 'translateY(100%)'
        }))
      ])
    ])
  ]
})

export class OrderDetailsListComponent implements OnInit {
	@HostBinding('@routeAnimation') get routeAnimation() {
		return true;
	}

	@HostBinding('style.display') get display() {
		return 'block';
	}
	
	OrderDetailsList: OrderDetailsData[];
	newOrderDetails: OrderDetailsData;
	selectedOrderDetails: OrderDetailsData;
	errorMessage: string;
	messages: string[];
	showAdd: boolean;
	@ViewChild(OrderDetailsSearchComponent) filterComponent: OrderDetailsSearchComponent;

	sortExpression: string = "OrderID";
	filterExpression: string = "";
	pageIndex: number = 1;
	pageSize: number = 10;
	endRowIndex: number;
	rowsCount: number;
	pageCount: number;
	isFirstPage: boolean;

    private selectedId: string;

	constructor(
		private OrderDetailsService: OrderDetailsService,
		private route: ActivatedRoute,
		private router: Router,
		private toastr: ToastsManager
	) {
		this.newOrderDetails = new OrderDetailsData();
		this.pageSize = myGlobals.pageSize;
	}

	ngOnInit() {
		//this.OrderDetailsService.getAll().subscribe(record => this.OrderDetailsList=record);
		this.pageIndex = 1;
		this.isFirstPage = true;
		this.getOrderDetailsByPaging();

		/*
		this.OrderDetailsList = this.route.params
			.switchMap((params: Params) => {
				this.selectedId = +params['id'];
				return this.service.getAll();
			});
		*/
	}

	// Get all records
	public getOrderDetails() {
		this.OrderDetailsService.getAll()
			.subscribe(data => this.OrderDetailsList = data,
		error =>  this.errorMessage = 'There was an error while retrieving records. Error: ' + <any>error);
	}
	
	// On Search CLick on OrderDetailsSearch Component
	onSearch(searchText: string) {
		// 1. Update this.filterExpression
		this.filterExpression = searchText;

		// 2. call getOrderDetailsByPaging method that will refresh the data
		this.pageIndex = 1;
		this.getOrderDetailsByPaging();
	}
	
	onSort(event, sortColumn: string)
	{
		// var target = event.target || event.srcElement || event.currentTarget;
		// var parent = target.parentNode;
		if (this.sortExpression === sortColumn)
			this.sortExpression = sortColumn + ' desc';
		else if (this.sortExpression === sortColumn + ' desc')
			this.sortExpression = sortColumn;
		else
			this.sortExpression = sortColumn;
		this.getOrderDetailsByPaging();
	}
	
	// Get records by paging
	getOrderDetailsByPaging() {
		this.OrderDetailsService.getAllByPaging(this.filterExpression, this.sortExpression, this.pageIndex, this.pageSize)
			.subscribe(data => {
				this.OrderDetailsList=data.OrderDetailsList;
				this.rowsCount=data.RowsCount;
				this.pageCount= Math.ceil(this.rowsCount / this.pageSize);
				if (this.pageIndex == 1)
					this.isFirstPage = true;
				else
					this.isFirstPage = false;
				if (this.pageIndex == this.pageCount)
					this.endRowIndex = this.rowsCount;
				else
					this.endRowIndex = this.pageIndex * this.pageSize;
			},
			error =>  this.errorMessage = 'There was an error while retrieving records. Error: ' + <any>error
		);
	}

	// Adds new record
	addOrderDetails() {
		this.OrderDetailsService.addOrderDetailsData(this.newOrderDetails).subscribe(record => console.log(record));
		this.getOrderDetails();
	}

	// Updates existing record
	updateOrderDetails() {
		this.OrderDetailsService.updateOrderDetailsData(this.selectedOrderDetails).subscribe(record => console.log(record));
		this.getOrderDetails();
	}

	// Deletes record with specified id
	deleteOrderDetails(id: string) {
		if (window.confirm('Are you sure you want to delete this OrderDetails?') == true)
		{
			this.OrderDetailsService.deleteOrderDetails(id)
			.subscribe(data => this.getOrderDetails(),
			error =>  this.errorMessage = 'There was an error while deleting record. Error: ' + <any>error,
				() => { 
					this.toastr.success('OrderDetails record deleted successfully...', 'Delete OrderDetails');
					console.log('OrderDetails record deleted successfully...'); 
				}
			);
		}
	}

	// Go to First Page
	onFirstPage() {
		this.pageIndex = 1;
		this.getOrderDetailsByPaging();
	}

	// Go to Previous Page
	onPreviousPage() {
		if (this.pageIndex > 1) {
			this.pageIndex = this.pageIndex - 1;
			this.getOrderDetailsByPaging();
		}
	}

	// Refresh - Go to First Page
	onRefresh() {
		this.onFirstPage();
	}

	// Go to Next Page
	onNextPage() {
		if (this.pageIndex < this.pageCount) {
			this.pageIndex = this.pageIndex + 1;
			this.getOrderDetailsByPaging();
		}
	}

	// Go to Last Page
	onLastPage() {
		this.pageIndex = this.pageCount;
		this.getOrderDetailsByPaging();
	}

	// On Edit - Go to Edit page
	onSelect(item: OrderDetailsData) {
		this.router.navigate(['/OrderDetails', item.OrderID]);
	}

	// On Details - Go to Details page
	onSelectDetails(item: OrderDetailsData) {
		this.router.navigate(['/OrderDetails/Details', item.OrderID]);
	}

	// Set record as selected
	SelectOrderDetails(item: OrderDetailsData) {
		this.selectedOrderDetails = item;
	}

	// Submits form
	submitForm(data: Object) {
		console.log(data);
	}

	// Logs message onto Console
	log(msg: string) {
		this.messages.splice(0, 0, msg);
		console.log(msg);
	}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/OrderDetails/OrderDetailsList.component.ts